import { render } from "./MyCarSection.vue?vue&type=template&id=07a17402&scoped=true"
const script = {}

import "./MyCarSection.vue?vue&type=style&index=0&id=07a17402&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a17402"]])

export default __exports__